import React, { useEffect } from "react";
import Layout from "../components/layout/layout";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid, IconButton,
  Snackbar,
  Typography,
} from "@material-ui/core";
import Copy from "../assets/svgs/icons/copy.svg";
import { copyToTheClipboard } from "../utils/helpers";
import { Alert } from "@material-ui/lab";
import cx from "classnames";
import CustomButton from "../components/shared/custom-button";
import Phone from "../assets/images/contact/phone.svg";
import FullPhone from "../assets/images/contact/full-phone.svg";
import Email from "../assets/images/contact/email.svg";
import {
  ANTI_BOT,
  HELPFUL_RESOURCES,
  STATUS,
} from "../constants/contact";
import queryString from "query-string";
import GoogleMap from "../components/shared/googleMap";
import ZohoContactForm from "../components/contact/zoho-contact-form";
import "../components/shared/styles.css";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "grid",
    gridTemplateColumns: "1fr 241px",
    gridTemplateRows: "306px 1fr",
    width: "100%",
    gap: "30px",

    [theme.breakpoints.down(840)]: {
      display: "flex",
      flexDirection: "column",
      gap: 0,
    },
  },
  mainContainer: {
    maxWidth: 1020,
    margin: "auto",
    padding: "0 24px",
    marginBottom: 50,
  },
  title: {
    width: "100%",
    marginBottom: 80,

    [theme.breakpoints.down(840)]: {
      textAlign: "center",
    },
  },
  description: {
    marginBottom: 55,

    [theme.breakpoints.down(840)]: {
      textAlign: "center",
    },
  },
  subTitle: {
    fontSize: "1.25rem",
    marginBottom: 20,

    [theme.breakpoints.down(840)]: {
      textAlign: "center",
    },
  },
  helpfulLinks: {
    gridColumnStart: 1,
    gridRowStart: 1,

    [theme.breakpoints.down(840)]: {
      borderBottom: "1px solid #D7D7D7",
    },
  },
  helpfulLinksContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 55,
    textTransform: "initial",
    maxWidth: 500,

    [theme.breakpoints.down(840)]: {
      margin: "auto",
      marginBottom: 55,
    },
  },
  contactForm: {
    display: "flex",
    flexDirection: "column",
    gridColumnStart: 1,
    gridRowStart: 2,
    marginBottom: 100,
  },
  contactInfo: {
    display: "flex",
    width: "100%",
    minWidth: 241,
    gridColumnStart: 2,
    gridRowStart: 1,
    gridRowEnd: 2,
    [theme.breakpoints.down(840)]: {
      margin: "30px 0",
    },
  },
  contactInfoList: {
    listStyle: "none",
    paddingLeft: 0,
    width: "100%",
  },
  copyRow: {
    display: "flex",
    alignItems: "center",

    [theme.breakpoints.down(840)]: {
      justifyContent: "center",
      paddingLeft: 44,
    },
  },
  copyButton: {
    marginBottom: 0,
  },
  startIcon: {
    margin: "0 -4px",
  },
  copyButtonIcon: {
    marginLeft: 10,
    padding: "8px 13.5px",
  },
  buttonIcon: {
    margin: "4px 0",
  },
  fullPhone: {
    margin: "0 0 18px 10px",
    borderRadius: 20,

    [theme.breakpoints.down(840)]: {
      marginLeft: -44,
    },
  },
  mapSection: {
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints.down(840)]: {
      flexDirection: "column-reverse",
      marginTop: 60,
    },
  },
  mapInfo: {
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints.down(840)]: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 20,
    },
  },
  addressTitle: {
    fontSize: ".7rem",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    fontWeight: 500,
    marginTop: 40,
    marginBottom: 8,

    [theme.breakpoints.down(840)]: {
      display: "none",
    },
  },
  address: {
    fontSize: "1rem",
    color: theme.palette.text.secondary,
  },
  map: {
    width: "100%",
    maxHeight: 219,
    height: "50vw",
    display: "flex",
  },
  mapTag: {
    color: "#CA3333",
    fontSize: "1rem",
    fontWeight: 500,
  },
  helpfulLinkItemContainer: {
    boxShadow: "none",
    borderRadius: 10,
    width: "100%",
    minWidth: 218,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 30,
    marginLeft: 0,
    "&:hover": {
      backgroundColor: "#FFFFFF",
      boxShadow: "1px 13px 27px -6px rgb(0 0 0 / 26%)",
    },

    [theme.breakpoints.down(540)]: {
      minWidth: 60,
    },
  },
  helpfulLinkItemContainerMobile: {
    border: "1px solid #D4D4D4",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#FFFFFF",
      boxShadow: "none",
    },
  },
  helpfulLinkItemLabel: {
    display: "flex",
    flexDirection: "column",
    textTransform: "inherit",
  },
  helpfulLinkTitle: {
    fontSize: "1.2rem",
    color: "#F15A29",
    textTransform: "initial",
    textAlign: "center",
  },
  helpfulLinkText: {
    marginTop: 10,
    fontSize: ".7rem",
    textTransform: "uppercase",

    [theme.breakpoints.down(540)]: {
      display: "none",
    },
  },
}));

const initialSnackbarData = {
  status: "",
  text: "",
  open: false,
};

const ContactUs = (props) => {
  const classes = useStyles();
  const parsedQuery = queryString.parse(props.location.search);
  const [snackbarState, setSnackbarState] = React.useState(initialSnackbarData);
  const [isItDesktop, setIsItDesktop] = React.useState(false);

  useEffect(() => {
    setIsItDesktop(/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent));
  }, []);

  const handleClick = (data) => {
    setSnackbarState(data);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarState(initialSnackbarData);
  };

  const copy = event => {
    const id = event.currentTarget.id;
    copyToTheClipboard(ANTI_BOT[id].value);
    handleClick({
      status: STATUS.success,
      text: `Slate Pages ${ANTI_BOT[id].title} copied to your clipboard`,
      open: true,
    });
  };

  const callNumber = () => {
    window && window.open(`tel:${ANTI_BOT.phone.value.replaceAll("test", "")}`, "_self");
  };
  const sendEmail = () => {
    window && window.open(`mailto:${ANTI_BOT.email.value.replaceAll("test", "")}`, "_self");
  };

  const HelpfulLink = ({ title, to, description }) => (
    <CustomButton
      color="secondary"
      variant="contained"
      href={to}
      ml={1}
      className={cx(classes.helpfulLinkItemContainer, { [classes.helpfulLinkItemContainerMobile]: isItDesktop })}
      classes={{
        label: classes.helpfulLinkItemLabel,
      }}
    >
      <Typography variant="h2" className={classes.helpfulLinkTitle}>
        {title}
      </Typography>
      <Typography className={classes.helpfulLinkText}>
        {description}
      </Typography>
    </CustomButton>
  );

  let { open, status, text } = snackbarState;

  return (
    <Layout SeoProps={{ title: `ContactUs` }} HeaderProps={{ path: props.path }}>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={status}>
          {text}
        </Alert>
      </Snackbar>
      <Grid
        container
        className={classes.mainContainer}
      >
        <Typography variant="h2" className={classes.title}>
          Contact Us
        </Typography>
        <div className={classes.wrapper}>
          <div className={classes.helpfulLinks}>
            <Typography className={classes.description}>
              Have questions? We're here to help! Contact us by phone, email, or
              send us a message with our contact form below. Whatever you choose,
              you'll hear back from us promptly.
            </Typography>
            <Typography variant="h4" className={classes.subTitle}>
              Helpful resources
            </Typography>
            <div className={classes.helpfulLinksContainer}>
              {
                HELPFUL_RESOURCES.map(item => (
                  <HelpfulLink {...item} key={item.title} />
                ))
              }
            </div>
          </div>
          <div className={classes.contactInfo}>
            <ul className={classes.contactInfoList}>
              <li className={classes.copyRow}>
                <CustomButton variant="contained"
                              color="primary"
                              mb={3}
                              onClick={callNumber}
                              className={classes.copyButton}
                              classes={{
                                startIcon: classes.startIcon,
                              }}
                              startIcon={<img alt="phone" src={Phone} className={classes.buttonIcon} />}
                />
                <IconButton aria-label="delete" className={classes.copyButtonIcon}>
                  <div onClick={copy} id={"phone"}><Copy color={"primary"} /></div>
                </IconButton>
              </li>
              <li className={classes.copyRow}>
                <IconButton aria-label="delete" className={classes.fullPhone} onClick={callNumber}>
                  <img alt="Full Phone" src={FullPhone} />
                </IconButton>
              </li>
              <li className={classes.copyRow}>
                <CustomButton variant="contained"
                              color="primary"
                              mb={3}
                              onClick={sendEmail}
                              className={classes.copyButton}
                              classes={{
                                startIcon: classes.startIcon,
                              }}
                              startIcon={<img alt="email" src={Email} className={classes.buttonIcon} />}
                />
                <IconButton aria-label="delete" className={classes.copyButtonIcon}>
                  <div onClick={copy} id={"email"}><Copy color={"primary"} /></div>
                </IconButton>
              </li>
              <li className={classes.mapSection}>
                <div className={classes.mapInfo}>
                  <div className={classes.addressTitle}>
                    address
                  </div>
                  <div className={classes.address}>
                    16 Hamilton Street<br />
                    West Haven CT 06516
                  </div>
                </div>
                <div className={classes.map}>
                  <GoogleMap style={classes.map} tagStyle={classes.mapTag} />
                </div>
              </li>
            </ul>
          </div>
          <div className={classes.contactForm}>
            <Typography variant="h2" className={classes.subTitle}>
              Questions? Ask us!
            </Typography>
            <ZohoContactForm
              defaultSubject={parsedQuery.subject}
              defaultMessage={parsedQuery.message}
            />
          </div>
        </div>
      </Grid>
    </Layout>
  );
};

export default ContactUs;